import { useMemo } from 'react';
import { api } from '@/redux/api';
import { ListUnitAddressBooksResponse } from '@/types/address-book';
import { useCurrentOrganisation } from './use-current-organisation';
import { useCurrentUnit } from './use-current-unit';

export const useUnitAddressBooks = () => {
  const { data: unit } = useCurrentUnit();
  const { organisation } = useCurrentOrganisation();

  const result = api.useListUnitAddressBooksQuery({
    organisationId: organisation!.id,
    unitId: unit!.id,
    actionType: 'listUnitAddressBooks',
  });
  const data: ListUnitAddressBooksResponse =
    useMemo(() => result.data, [result.data]) ?? [];
  return { ...result, data };
};

export const useAddressBooks = () => {
  const { data: unit } = useCurrentUnit();
  const { organisation } = useCurrentOrganisation();

  const result = api.useListAddressBooksQuery({
    organisationId: organisation!.id,
    unitId: unit!.id,
    actionType: 'listAddressBooks',
  });
  const data = useMemo(() => result.data, [result.data]) ?? [];
  return { ...result, data };
};
